import { createRouter, createWebHistory } from 'vue-router';

const routes = [
  {
    path: '/',
    redirect: { name: 'dashboard' },
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    component: () => import('@/views/DashboardView.vue'),
    meta: { title: 'Coverage Dashboard' },
  },
  {
    path: '/ask',
    name: 'ask',
    component: () => import('@/views/AskView.vue'),
    meta: { title: 'Ask the Research Agent' },
  },
  {
    path: '/hackathon',
    name: 'hackathon',
    component: () => import('@/views/HackathonView.vue'),
    meta: { title: 'Hackathon Presentation' },
  },
  {
    path: '/history',
    name: 'history',
    component: () => import('@/views/HistoryView.vue'),
    meta: { title: 'Form Version History' },
  },
  {
    path: '/forms',
    name: 'forms',
    component: () => import('@/views/FormsView.vue'),
    meta: { title: 'Form Search' },
  },
  {
    path: '/updates',
    name: 'updates',
    component: () => import('@/views/UpdatesView.vue'),
    meta: { title: 'Form Updates' },
  },
  {
    path: '/diff',
    name: 'diff',
    component: () => import('@/views/DiffView.vue'),
    meta: { title: 'Year-Over-Year Diff' },
  },
  {
    path: '/taxlogic',
    name: 'taxlogic',
    component: () => import('@/views/TaxLogicView.vue'),
    meta: { title: 'TaxLogic Outline Generator' },
  },
  {
    path: '/schema-diff',
    redirect: { name: 'analyses' },
  },
  {
    path: '/jurisdictions',
    name: 'jurisdictions',
    component: () => import('@/views/JurisdictionsView.vue'),
    meta: { title: 'Jurisdictions' },
  },
  {
    path: '/ingest',
    name: 'ingest',
    component: () => import('@/views/IngestView.vue'),
    meta: { title: 'Ingest Status' },
  },
  {
    path: '/analyses',
    name: 'analyses',
    component: () => import('@/views/AnalysesView.vue'),
    meta: { title: 'AI Change Analyses' },
  },
  {
    path: '/failures',
    name: 'failures',
    component: () => import('@/views/FailuresView.vue'),
    meta: { title: 'Failed Documents' },
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.afterEach((to) => {
  document.title = to.meta?.title ? `${to.meta.title} · TaxHawk Form Research` : 'TaxHawk Form Research';
});

export default router;
